import { styled } from '@mui/material';

// Contexts
import { withTranslate } from '../../../../core/TenantProvider';
import withFlags from '../../../../core/FlagsProvider';
// Assets
import { ReactComponent as ManagementIcon } from '../assets/management-icon.svg';
// Components - Atoms, Molecules, Organisms, Pages
import APButton from '../../APButton';
// Types
import { TypographyStyleObject } from '../../../../core/types/TypographyTypes';
import { HexColour } from '../../../../core/types/ThemeConfigTypes';
// Utils
import { getBody2MediumStyles, getBodySmallNormalStyles } from '../../../../core/utils/GetTypographyStyles/GetTypographyStyles';
import { useNavigate } from 'react-router-dom';

const StyledGridOverlay = styled('div')(({ theme }) => {
    const {
        colours: {
            backgrounds: { background },
            text: { text }
        },
    } = theme;

    const BACKGROUND_COLOR: HexColour = background;
    const TEXT_COLOR: HexColour = text;
    const BODY_SMALL_NORMAL_TEXT: TypographyStyleObject = getBodySmallNormalStyles(theme);

    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        backgroundColor: BACKGROUND_COLOR,
        ...BODY_SMALL_NORMAL_TEXT,
        color: TEXT_COLOR
    }
});

const IconContainer = styled('div')({
    marginBottom: 20
});

const StyledHeader = styled('div')(({ theme }) => {
    return {
        ...getBody2MediumStyles(theme),
        color: '#0A0A0A',
        marginBottom: 8
    }
});

const StyledSubHeader = styled('div')(({ theme }) => {
    return {
        ...getBody2MediumStyles(theme),
        color: '#A4A4A4',
        marginBottom: 20
    }
});

const APDataTableNoRowsOverlay = (props): React.JSX.Element => {
    const { translate, flags = {} } = props;
    const navigate = useNavigate();

    const noDataAvailableLabel: string = translate('clientmanagement.table.no.clients');
    const subTitleLabel: string = translate('clientmanagement.table.no.clients.subtitle');

    const shouldEnableRAC: boolean = flags?.enableRegisterClientFlow ?? true;

    const handleRegisterClientClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        navigate('/register_client')
    }

    return (
        <StyledGridOverlay>
            <IconContainer>
                <ManagementIcon />
            </IconContainer>
            <StyledHeader>{noDataAvailableLabel}</StyledHeader>
            <StyledSubHeader>{subTitleLabel}</StyledSubHeader>
            {shouldEnableRAC &&
                <APButton
                    // className={classes.headerButton}
                    variant="contained"
                    onClick={handleRegisterClientClick}
                    color="primary"
                >
                    {translate('clientmanagement.header.registerclientbutton.label')}
                </APButton>}
        </StyledGridOverlay>
    );
}

export default withFlags(
    withTranslate(APDataTableNoRowsOverlay)
);